import React from 'react';
import styled from 'styled-components';
import { DefinitionList } from '@openfin/ui-library';

import { TemplateComponentProps } from '..';
import { TemplateList } from '../../../../../client/templates/templates';

type Props = TemplateComponentProps<TemplateList>;

export const TemplateListComponent: React.FC<Props> = (props) => {
  const { notification } = props;
  return (
    <DefinitionListContainer>
      <DefinitionList definitions={new Map(Object.entries(notification.notification.list))} />
    </DefinitionListContainer>
  );
};

const DefinitionListContainer = styled.div`
  flex: 1;
  width: 100%;
`;
